<template>
  <main class="main main--link">
    <div class="gradient-bg">
      <module-spinner
        :active="true"
        :floating="true"
      />
    </div>
  </main>
</template>

<script>
import ModuleSpinner from 'modules/Spinner';

import axios from 'axios';
import config from 'config';

export default {
  name: `track-link`,
  components: {
    ModuleSpinner,
  },
  beforeCreate() {
    const link = this.$route.params.redirect || false;
    const payload = this.$route.params.payload || false;

    if(payload && link) {
      axios.post(`${config.api}/link`, {
        payload,
        link,
      }).then(() => {
        // pass
      }).catch(() => {
        // pass
      });

      window.location = link;
    }
    return this.$router.replace({
      name: `notFound`,
    });
  },
};
</script>



// WEBPACK FOOTER //
// TrackLink.vue?0b4fa9a6